// NPM Imports
import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cloneDeep } from "lodash";

// Components Imports
import SignatureContentHandling from "./SignatureContentHandling";
import AddAnotherSignature from "./AddAnotherSignature";

// Services Imports
import { getAllTeammatesUsersService } from "../../../actions/UserActions/userService";

// Internal Imports
import { DocumentUtils, GlobalUtils } from "../../../utils";
import {
  updateDataForSignatureSection,
  updateDataForTemplateSignatureSection,
  deleteDocSignerSection,
  deactivateComponentIfActive,
  updateDocSignatoriesAction,
  addEsignBlockData,
  executeCommand,
} from "../../../actions/DocumentActions";
import { QuotationActions } from "../../../actions";
import { DOCUMENTS } from "../../../constants";
import { updateTemplateSection } from "../../../actions/DocumentTemplateActions/templateActions";
import AddSignBlockCommand from "../../../commands/addSignBlockCommand";
import DeleteSignBlockCommand from "../../../commands/deleteSignBlockCommand";
import SignatureTypeChangeCommand from "../../../commands/signatureTypeChangeCommand";
import SignatureConfigChangeCommand from "../../../commands/signatureConfigChangeCommand";
import SignatureSignerChangeCommand from "../../../commands/signatureSignerChangeCommand";
import SignatureSignerRemoveCommand from "../../../commands/signatureSignerRemovedCommand";
import SignatureAddContactCommand from "../../../commands/signatureAddContactCommand";

// Destructuring
const { getSignatureConfigJson, convertSignersData } = DocumentUtils;
const { setSectionDataForActiveSignatureInRightToolPane } = QuotationActions;
const { validateEmail } = GlobalUtils;
const { DOCUMENT_MODE } = DOCUMENTS;

class SignatureList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: props.mode,
      signBlocks:
        props.sectionDataForSignature.data &&
        props.sectionDataForSignature.data.length > 0
          ? JSON.parse(JSON.stringify(props.sectionDataForSignature.data))
          : JSON.parse(JSON.stringify(getSignatureConfigJson())),
      signerOptions: [],
    };
  }

  componentDidMount() {
    this._fetchTeammates();
  }

  static getDerivedStateFromProps(nextProps) {
    if (
      nextProps.sectionDataForSignature.id &&
      nextProps.sectionDataForSignature.data
    ) {
      return {
        sectionId: nextProps.sectionDataForSignature.id,
        mode: nextProps.mode,
        signBlocks:
          nextProps.sectionDataForSignature.data.length > 0
            ? JSON.parse(JSON.stringify(nextProps.sectionDataForSignature.data))
            : JSON.parse(JSON.stringify(...getSignatureConfigJson())),
      };
    }
    return null;
  }

  componentWillUnmount() {
    this.setState({
      signBlocks: [],
    });
    // update component id to null
    if (this.props.clickedActiveComponentType === "Signature")
      this.props.deactivateComponentIfActive(
        this.props.clickedActiveComponentId,
      );
  }

  _fetchTeammates = async () => {
    const options = [];
    const userData = await getAllTeammatesUsersService();
    if (userData.users && userData.users.length > 0) {
      userData.users.forEach(d => {
        options.push({
          value: d.user_email,
          firstName: d.first_name,
          lastName: d.last_name,
          image_url: d.image_url,
          label: d.user_email,
        });
      });
    }

    this.setState({
      signerOptions: options,
    });
  };

  _setState = payload => {
    this.setState(payload);
  };

  _addNewSignerToSignerOption = (email, firstName, lastName) => {
    const { signerOptions } = this.state;
    if (signerOptions.findIndex(op => op.value === email) === -1) {
      this.setState({
        signerOptions: [
          ...signerOptions,
          {
            value: email,
            firstName,
            lastName,
            image_url: "",
            label: email,
          },
        ],
      });
    }
  };

  _onAddSignBlock = async () => {
    const addSignBlockCommand = new AddSignBlockCommand({
      mode: this.props.mode,
      sectionDataForSignature: cloneDeep(this.props.sectionDataForSignature),
      docId: this.props.docId,
      signatories: cloneDeep(this.props.signatories),
      updateDocSignatoriesAction: this.props.updateDocSignatoriesAction,
      setState: this._setState,
      signBlocks: cloneDeep(this.state.signBlocks),
      onSectionUpdate: this._onSectionUpdate,
      removeSignerData: this._removeSignerData,
      updateActiveSignatureData: this._updateActiveSignatureData,
      deleteDocSignerSection: this.props.deleteDocSignerSection,
    });
    this.props.executeCommand(addSignBlockCommand);
  };

  _removeSignerData = (
    signerIndex,
    undoable,
    oldSignBlocks,
    oldSignatories,
  ) => {
    const deleteSignBlockCommand = new DeleteSignBlockCommand({
      signatories: oldSignatories
        ? cloneDeep(oldSignatories)
        : cloneDeep(this.props.signatories),
      signerIndex,
      mode: this.props.mode,
      sectionDataForSignature: cloneDeep(this.props.sectionDataForSignature),
      deleteDocSignerSection: this.props.deleteDocSignerSection,
      docId: this.props.docId,
      signBlocks: oldSignBlocks
        ? cloneDeep(oldSignBlocks)
        : cloneDeep(this.state.signBlocks),
      onSectionUpdate: this._onSectionUpdate,
      setState: this._setState,
      updateDocSignatoriesAction: this.props.updateDocSignatoriesAction,
      updateActiveSignatureData: this._updateActiveSignatureData,
    });
    deleteSignBlockCommand.unDoable = undoable || true;

    this.props.executeCommand(deleteSignBlockCommand);
  };

  /* This is the responsibel for handling searchable/select/clear(creatable dropdown) 
   & firstName & lastName */

  _handleValue = (e, i, name, value = "") => {
    const data = [...this.state.signBlocks];
    if (name === "signerEmail") {
      if (e === null) {
        const signerRemovedCommand = new SignatureSignerRemoveCommand({
          data: cloneDeep(data),
          event: e,
          index: i,
          onSectionUpdate: this._onSectionUpdate,
          setState: this._setState,
        });
        this.props.executeCommand(signerRemovedCommand);
      } else if (e.__isNew__ === true) {
        data[i].signer_email = e.value.toLowerCase().trim();
        data[i].notValid = !validateEmail(e.value);
        data[i].first_name = "";
        data[i].last_name = "";
        data[i].signer_config = { ...data[i].signer_config };
        data[i].signer_config.image_url = "";
        data[i].showNameField = true;
        data[i].internalUser = false;
        data[i].signer_config.signature_type =
          data[i].signer_config.signature_type;
        data[i].signer_config.showAuth = false;
        this.setState(() => ({ signBlocks: data }));
        this._updateActiveSignatureData(
          data,
          undefined,
          this.props.sectionDataForSignature.id,
        );
      } else {
        const signerChangeCommand = new SignatureSignerChangeCommand({
          data: cloneDeep(data),
          event: e,
          index: i,
          onSectionUpdate: this._onSectionUpdate,
          setState: this._setState,
        });
        this.props.executeCommand(signerChangeCommand);
      }
    } else {
      data[i][name] = value;
      this.setState(() => ({ signBlocks: data }));
      this._updateActiveSignatureData(
        data,
        undefined,
        this.props.sectionDataForSignature.id,
      );
    }
  };

  _checkIfBlockGoingOutOfBound = data => {
    const signatureContainer = document
      .getElementById(this.props.clickedActiveComponentId)
      .getBoundingClientRect();
    const canvas = document
      .querySelector(
        `div.document-page-wrapper-${data.signer_config.point.page_no + 1}`,
      )
      .getBoundingClientRect();

    const canvasHeight = canvas.height - 25; // Canvas height - 25px canvas margin bottom handle
    const signatureBlockHeigh = data.signer_config.options[0].height;
    const signatureContainerHeight =
      signatureContainer.height + signatureBlockHeigh;
    const yAxis = signatureContainer.top - canvas.top;
    // Prevent content going out of bound, do the below calc & update the value
    if (yAxis + signatureContainerHeight > canvasHeight) {
      return true;
    }
    return false;
  };

  // This code handles ==> when user start drag & drop or position changing.
  _updateSignerConfig = (
    signerIndex,
    updatedSignerConfig,
    isAdditionalFieldsChanged,
    oldSignerConfig,
  ) => {
    const data = [...this.state.signBlocks];
    const signatureConfigChangeCommand = new SignatureConfigChangeCommand({
      data,
      isPdfDocument: this.props.isPdfDocument,
      isAdditionalFieldsChanged,
      signerIndex,
      updatedSignerConfig: cloneDeep(updatedSignerConfig),
      oldSignerConfig: cloneDeep(oldSignerConfig),
      setState: this._setState,
      checkIfBlockGoingOutOfBound: this._checkIfBlockGoingOutOfBound,
      onSectionUpdate: this._onSectionUpdate,
    });
    this.props.executeCommand(signatureConfigChangeCommand);
  };

  // This code handles ==> when user click on edit icon.
  _editProcessInternalUser = index => {
    const data = JSON.parse(JSON.stringify(this.state.signBlocks));
    data[index].internalUser = false;
    data[index].showNameField = true;
    data[index].updateProcess = true;
    this.setState(() => ({ signBlocks: data }));
    this._updateActiveSignatureData(
      data,
      undefined,
      this.props.sectionDataForSignature.id,
    );
  };

  // This code handles ==> when user click on Add contact button.
  _addSignerDetails = index => {
    const signatureAddContactCommand = new SignatureAddContactCommand({
      index,
      data: cloneDeep(this.state.signBlocks),
      setState: this._setState,
      onSectionUpdate: this._onSectionUpdate,
    });
    this.props.executeCommand(signatureAddContactCommand);
  };

  // This code handles ==> when user click on Cancel button.
  _cancleUpdateDetails = index => {
    const data = JSON.parse(JSON.stringify(this.state.signBlocks));
    data[index].internalUser = true;
    data[index].showNameField = false;
    data[index].updateProcess = false;
    this.setState(() => ({ signBlocks: data }));
    this._updateActiveSignatureData(
      data,
      undefined,
      this.props.sectionDataForSignature.id,
    );
  };

  // This code handles ==> api interaction for the document section update.
  _onSectionUpdate = (
    signerData,
    undoable,
    newSignerBlocks,
    dontDeleteNameField,
  ) => {
    const sectionDataForSignature = JSON.parse(
      JSON.stringify(this.props.sectionDataForSignature),
    );
    const signBlocks = JSON.parse(
      JSON.stringify(newSignerBlocks || this.state.signBlocks),
    );
    const data = [];
    signBlocks.forEach(d => {
      d.errMsg = undefined;
      d.disabled = undefined;
      if (!dontDeleteNameField && signerData.id === d.id) {
        d.showNameField = undefined;
        d.updateProcess = undefined;
      }
      d.notValid = undefined;
      data.push(d);
    });
    if (sectionDataForSignature.data && data.length > 0) {
      sectionDataForSignature.data = data;
      if (this.props.mode === DOCUMENT_MODE.TEMPLATE) {
        this.props.updateDataForTemplateSignatureSection(
          sectionDataForSignature,
        );
      } else {
        const updatedSignerData = [
          {
            component_id: sectionDataForSignature.id,
            signers: [{ ...signerData }],
          },
        ];
        this.props.updateDataForSignatureSection(
          updatedSignerData,
          this.props.docId,
        );
      }
      this.props.setSectionDataForActiveSignatureInRightToolPane(
        sectionDataForSignature,
      );
    } else if (this.props.isPdfDocument) {
      this.props.addEsignBlockData(this.props.docId, data);
    }
  };

  _stopClickEventPropagation = event => {
    event.nativeEvent.stopImmediatePropagation();
  };

  _handleEsignTypeValue = (event, signerIndex) => {
    const data = [...this.state.signBlocks];
    const singatureTypeChangeCommand = new SignatureTypeChangeCommand({
      data,
      event,
      signerIndex,
      setState: this._setState,
      onSectionUpdate: this._onSectionUpdate,
    });

    this.props.executeCommand(singatureTypeChangeCommand);
  };

  _updateActiveSignatureData = (
    newSignerBlocks,
    updatedSignatories,
    componentId,
  ) => {
    const sectionDataForSignature = JSON.parse(
      JSON.stringify(this.props.sectionDataForSignature),
    );
    const signBlocks = JSON.parse(
      JSON.stringify(newSignerBlocks || this.state.signBlocks),
    );
    if (sectionDataForSignature.data && signBlocks.length > 0) {
      sectionDataForSignature.data = signBlocks;
      if (componentId === sectionDataForSignature.id) {
        this.props.setSectionDataForActiveSignatureInRightToolPane(
          sectionDataForSignature,
        );
      }

      if (updatedSignatories) {
        this.props.updateDocSignatoriesAction(updatedSignatories);
      } else {
        let updatedSignerData = JSON.parse(
          JSON.stringify(this.props.signatories),
        );
        let found = false;
        updatedSignerData.forEach(signer => {
          if (signer.component_id === sectionDataForSignature.id) {
            signer.signers = [...signBlocks];
            found = true;
          }
        });
        if (!found) {
          if (!updatedSignerData) updatedSignerData = [];
          updatedSignerData.push({
            component_id: sectionDataForSignature.id,
            signers: [...signBlocks],
          });
        }
        this.props.updateDocSignatoriesAction(updatedSignerData);
      }
    }
  };

  render() {
    const { signBlocks, signerOptions, mode } = this.state;
    const { clickedActiveComponentId } = this.props;
    return (
      <Fragment>
        <div
          className="signature-pane-wrapper fadeinright animated"
          ref={this.props.signatureWrapperRef}
          onClick={this._stopClickEventPropagation}
          onKeyPress={() => {}}
          role="button"
          tabIndex="0">
          <div className="notes-header cover-page">
            <div
              className="right-pane-title"
              role="button"
              tabIndex={0}
              onClick={this.props.hideEditPane}
              onKeyDown={() => {}}>
              <div>Signature block</div>
              <div className="pane-close-icon">
                <i>
                  <FontAwesomeIcon icon={["far", "times-circle"]} />
                </i>
              </div>
            </div>
          </div>

          <div className="signature-body-wrapper">
            <div className="content-scroll">
              <span
                className="addproduct-info margin-bottom"
                data-test="addsignature-details-info">
                {mode === DOCUMENT_MODE.TEMPLATE
                  ? "Add placeholders for signature blocks."
                  : "Add signer details to the signer tags below in this block"}
              </span>
              {Array.isArray(signBlocks) && signBlocks.length > 0
                ? signBlocks.map((signblock, i) => {
                    let editMode = false;
                    let { showNameField } = signblock;
                    if (
                      signblock.signer_email &&
                      !(signblock.first_name || signblock.last_name)
                    ) {
                      showNameField = true;
                    }
                    if (
                      signblock.signer_email !== "" &&
                      signblock.internalUser !== undefined &&
                      !signblock.notValid &&
                      !signblock.internalUser
                    ) {
                      editMode = false;
                    } else if (signblock.internalUser !== undefined) {
                      editMode = signblock.internalUser;
                    } else if (
                      signblock.internalUser === undefined &&
                      signblock.signer_email !== "" &&
                      signblock.first_name &&
                      signblock.last_name
                    ) {
                      editMode = true;
                    }
                    return (
                      <SignatureContentHandling
                        key={`sig-content-handling-${clickedActiveComponentId}-key-${signblock.id ||
                          `${i + 1}-index`}`}
                        signblockData={signblock}
                        signerIndex={i}
                        removeSigner={this._removeSignerData}
                        showRemoveIcon={signBlocks.length > 1}
                        handleValue={this._handleValue}
                        editMode={editMode}
                        showNameField={showNameField}
                        dataUpdateOnBlur={this._dataUpdateOnBlur}
                        editProcessInternalUser={this._editProcessInternalUser}
                        updateSignerConfig={this._updateSignerConfig}
                        signerOptions={signerOptions}
                        addSignerDetails={this._addSignerDetails}
                        cancleUpdateDetails={this._cancleUpdateDetails}
                        mode={mode}
                        handleEsignTypeValue={this._handleEsignTypeValue}
                        addNewSignerToSignerOptions={
                          this._addNewSignerToSignerOption
                        }
                      />
                    );
                  })
                : null}
              {!this.props.isPdfDocument && (
                <AddAnotherSignature
                  mode={mode}
                  onAddSignBlock={this._onAddSignBlock}
                />
              )}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { mode } = props;
  const {
    document: { id: docId, signatories, isPdfDocument },
    clickedActiveComponentId,
    clickedActiveComponentType,
  } = state.DocumentStore;
  const { sectionDataForSignature } = state.ToolPaneStore;
  sectionDataForSignature.data = convertSignersData(
    sectionDataForSignature.data,
  );
  let signerData = [];
  if (mode === DOCUMENT_MODE.DOCUMENT)
    signatories.forEach(signer => {
      if (signer.component_id === sectionDataForSignature.id) {
        signerData = [...signer.signers];
      }
    });
  return {
    docId,
    signerData,
    signatories,
    sectionDataForSignature,
    clickedActiveComponentType,
    clickedActiveComponentId,
    isPdfDocument,
  };
};

const mapDispatchToProps = {
  updateDataForSignatureSection,
  updateDataForTemplateSignatureSection,
  updateTemplateSection,
  setSectionDataForActiveSignatureInRightToolPane,
  deleteDocSignerSection,
  deactivateComponentIfActive,
  updateDocSignatoriesAction,
  addEsignBlockData,
  executeCommand,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignatureList);



// WEBPACK FOOTER //
// ./src/components/DocumentComponents/SignatureListPane/index.js